import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import { isAuthorizedRoles } from "../../auth/Security"
import MustAuth from "../pages/MustAuth";
import NotAuthorized from "../pages/NotAuthorized";
import {useSelector} from "react-redux";
import {Redirect, useLocation} from "react-router-dom";
import Loader from "../layout/Loader";
import Message from "../pages/Message";
import BlockIcon from '@mui/icons-material/Block';
const PrivateRoute = ({roles, children, ...rest}) => {

    const { keycloak } = useKeycloak();
    const isAuthorized = roles.length > 0 ? isAuthorizedRoles(keycloak, roles) : true;
    const isLoggedIn = keycloak.authenticated;
    const { applications, user } = useSelector(state => state.account);
    const { perimetersV2, selectedPerimeter } = useSelector(state => state.extranet);
    const location = useLocation();

    const hasCodeEntreprise = () => {
        return selectedPerimeter && selectedPerimeter.hasOwnProperty("codeEntreprise") && selectedPerimeter.codeEntreprise !== null;
    }

    const verifyIsAppInPerimeter = () => {
        const pathname = location.pathname.split("/")[2];
        let message = "Vous n'avez pas accès au service ";
        switch (pathname) {
            case "sinistres-en-ligne":
                const sinistresFilter = applications.filter(app => app.code === "SINISTRES");
                message += "sinistres en ligne";
                if (sinistresFilter.length === 0) {
                    return <Redirect to={"/ui/not-access"} />;
                } else {
                    return hasCodeEntreprise() ? children : <Redirect to={"/ui/not-access"} />;
                }
            case "prestations":
                const prestationsFilter = applications.filter(app => app.code === "PRESTATIONS");
                message += "prestations";
                if (prestationsFilter.length === 0) {
                    return <Redirect to={"/ui/not-access"} />;
                } else {
                    return children;
                }
            case "affiliations":
                const affiliationsFilter = applications.filter(app => app.code === "AFFILIATIONS");
                message += "affiliations";
                if (affiliationsFilter.length === 0) {
                    return <Redirect to={"/ui/not-access"} />;
                } else {
                    return children;
                }
            case "administration":
                const administrationFilter = applications.filter(app => app.code === "ADMINISTRATION");
                message += "administrations de comptes";
                if (administrationFilter.length === 0) {
                    return <Redirect to={"/ui/not-access"} />;
                } else {
                    return children;
                }
            case "decomptes":
                const decomptesFilter = applications.filter(app => app.code === "DECOMPTES");
                message += "decomptes";
                if (decomptesFilter.length === 0) {
                    return <Redirect to={"/ui/not-access"} />;
                } else {
                    return children;
                }
            default:
                return  children
        }

    }

    // return isLoggedIn && isAuthorized ? children : keycloak.login();

    if (isLoggedIn) {
        if (isAuthorized) {
            // Test if user has applications CASE all users
            if (applications.length > 0) {
                // Test if user has perimetersV2
                if (user.type === "ENTREPRISE" && perimetersV2.length > 0) {

                    if (selectedPerimeter && selectedPerimeter.hasOwnProperty("codeEntreprise")) {
                        return verifyIsAppInPerimeter();
                    } else {
                        if (location.pathname === "/ui/choix-perimeter") {
                            return children
                        } else {
                            if (perimetersV2.length === 1) {
                                return children
                            } else {
                                return <Redirect to={"/ui/choix-perimeter"} />
                            }
                        }
                    }

                }
                else if(user.type === "ASSURE") {
                    return children
                }
                else {
                    return "here another case"
                    //return <Loader open />
                }
            }
            else {
                if (user && user.type === "UNIP") {

                    const selectedProfil = false;
                    // Verify if there is a userSelected
                    if (selectedProfil) {

                    } else {
                        // Else redirect to choose user interface
                        if (location.pathname === "/ui/choix-profil") {
                            return children
                        } else {
                            return <Redirect to={"/ui/choix-profil"} />
                        }
                    }

                } else {

                    return <Loader open /> //setTimeout(() => , 500)
                    // return children
                }
                //return <Loader open />
            }
        } else {
            return <NotAuthorized />
        }
    } else {
        return <MustAuth />;
    }

    //return isLoggedIn && isAuthorized ? children : <MustAuth />
}

export default PrivateRoute;
